<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            <a id="projectList" class="ml-1 list-type" @click="changeListType('projectList')">制作案件一覧</a>
            <a id="dataList" class="ml-1 list-type" @click="changeListType('dataList')">発注データ作成</a>
            <a id="orderList" class="ml-1 list-type active-list">発注履歴</a>
            <a id="deliveryEvaluation" class="ml-1 list-type" :href="deliveryEvaluationURL" target="deliveryEvaluation">納品評価</a>
            <a v-show="isAllowedAccess" id="materialsAndEquipmentAdjustmentList" class="ml-1 list-type" :href="materialsAndEquipmentAdjustmentListURL" target="materialsAndEquipmentAdjustmentList">資器材回し用一覧</a>
          </div>
        </div>

        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-blue text-left text-black" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-5 row pl-5">
                        <div class="row">
                          <label for="continent" class="control-label col-sm-12">発注日</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" name="continent" id="wedding-date-from" class="form-control input-sm" v-model="searchDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" name="continent" id="wedding-date-to" class="form-control input-sm" v-model="searchDateTo"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="reset" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>
                      <b-button class="main-color text-light w-25 ml-3" @click="searchOrder()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 案件制作一覧リスト -->
        <div id="search-list" class="row base-color mt-3">
          <div class="col-sm-12 row pt-3 pr-0">
            <div class="col-sm-6">
              検索結果<span class="h3 ml-1">{{orderLength}}</span><span class="ml-1 mr-2">件</span>{{orderLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
            </div>
          </div>
          <div class="col-sm-12 mt-3">
            <b-table-simple bordered class="small">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th class="align-middle text-center" style="width: 20%;">発注日時</th>
                  <th class="align-middle text-center" style="width: 20%;">内容確認</th>
                  <th class="align-middle text-center" style="width: 20%;">発注先</th>
                  <th class="align-middle text-center" style="width: 20%;">CSV</th>
                  <th class="align-middle text-center" style="width: 20%;">フレネット<br>連携実施結果</th>
                </tr>
              </thead>
              <b-tbody>
                <b-tr v-for="(order, index) in activeOrderList" :key="index + 'activeOrder'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                  <b-td class="align-middle">{{formatDate(order['発注日時']['value'])}}</b-td>
                  <b-td class="align-middle">
                    <b-button class="ml-1 mr-4 main-color button-font-small" @click="moveDetail(order['発注番号']['value'], order['フレネット']['value'])">
                      内容確認
                    </b-button>
                  </b-td>
                  <b-td class="align-middle">{{order['フレネット']['value'] ? 'フレネット' : 'その他'}}</b-td>
                  <b-td class="align-middle">
                    <b-button class="ml-1 mr-4 main-color button-font-small" @click="downloadCsv(order['発注番号']['value'], order['フレネット']['value'])">
                      ダウンロード
                    </b-button>
                  </b-td>
                  <b-td class="align-middle">{{order['フレネット']['value'] ? order['フレネット連携実施結果']['value'] : ''}}</b-td>
                </b-tr>
                <b-tr :key="index"></b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <div class="col-sm-12 row pt-3 pr-0">
            <div class="col-sm-4">
              検索結果<span class="h3 ml-1">{{orderLength}}</span><span class="ml-1 mr-2">件</span>{{orderLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
            </div>
            <div class="col-sm-4">
              <paginate
                v-model="page"
                :page-count="Math.ceil(orderLength / pageMaxNum)"
                :page-range="3"
                :margin-pages="2"
                :click-handler="movePage"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination justify-content-center'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </CommonLayout>
</template>

<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import OrderListModel from '@/models/OrderListModel'
import OrderCsvModel from '@/models/OrderCsvModel'
import CookieDataModel from '@/models/CookieDataModel'
import SaveCSV from 'file-saver'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

export default {
  name: 'OrderList',
  components: {
    CommonLayout
  },
  data () {
    return {
      overlayShow: false,
      activeOrderList: [],
      orderData: [],
      orderLength: 0,
      page: 1,
      pageMaxNum: 20,
      pageStart: 0,
      pageEnd: 0,
      searchDateFrom: '',
      searchDateTo: '',
      cookieIsAdmin: 0,
      cookieProdBaseCode: '',
      materialsAndEquipmentAdjustmentListURL: '',
      deliveryEvaluationURL: '',
      allowProdBaseList: ['03850', '303032', '3140', '8132', '107010', '20170', '05970', '06111', '6110', '6500', '02710', '10260', '107009', '15392', '15490', '1528001321', '107013', '15290', '878716'],
      isAllowedAccess: false
    }
  },
  methods: {
    movePage (pageNum) {
      this.page = pageNum
      this.setActiveOrderList()
    },
    setActiveOrderList () {
      this.pageStart = (this.page - 1) * this.pageMaxNum
      this.pageEnd = this.pageStart + this.pageMaxNum
      if (this.orderLength < this.pageEnd) {
        this.pageEnd = this.pageStart + (this.orderLength % this.pageMaxNum)
      }
      this.activeOrderList = this.orderData.slice(this.pageStart, this.pageEnd)
    },
    searchOrder () {
      this.page = 1
      this.overlayShow = true
      const reqData = {
        'date_from': this.searchDateFrom,
        'date_to': this.searchDateTo
      }
      if (this.cookieIsAdmin !== '1') {
        reqData['prodBaseCode'] = this.cookieProdBaseCode
      }
      OrderListModel.getApi(this.$bvModal, reqData, (data) => {
        this.orderData = data['orders']['records'].sort((a, b) => {
          return (a['発注日時']['value'] < b['発注日時']['value']) ? 1 : -1
        })
        this.orderLength = this.orderData.length
        this.setActiveOrderList()
      }, () => {
        this.overlayShow = false
      })

      // 検索条件を保存
      localStorage.setItem('searchConditions', JSON.stringify(reqData))
    },
    clearConditions () {
      this.searchDateFrom = ''
      this.searchDateTo = ''
    },
    moveDetail (orderNo, isFrenet) {
      this.$router.push(`/order_detail/${orderNo}?is_frenet=${isFrenet ? '1' : '0'}`)
    },
    downloadCsv (orderNo, isFrenet) {
      const reqData = {
        order_no: orderNo,
        is_frenet: isFrenet
      }

      OrderCsvModel.postApi(this.$bvModal, reqData, (res) => {
        console.log(isFrenet)
        if (isFrenet === true) {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, res.data.content], {type: res.headers['content-type']})
          SaveCSV(blob, res.data.fileName)
        } else {
          window.open(res.data.items.filePath, '_blank')
        }
      })
    },
    formatDate (date) {
      // 日付のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW) hh:mm'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      format = format.replace(/hh/g, ('0' + newDate.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + newDate.getMinutes()).slice(-2))
      return format
    },
    changeListType (target) {
      if (target === 'dataList') {
        this.$router.push('/project_list?list_type=dataList')
      } else {
        this.$router.push('/project_list?list_type=projectList')
      }
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    pageBackSetUp () {
      const searchConditions = JSON.parse(localStorage.getItem('searchConditions'))
      for (const [key, value] of Object.entries(searchConditions)) {
        if (key === 'date_from') {
          this.searchDateFrom = value
        } else if (key === 'date_to') {
          this.searchDateTo = value
        }
      }
      this.searchOrder()
      localStorage.removeItem('isOrderPageBack')
    },
    setCookieData: async function () {
      this.CookieData = await CookieDataModel.getApi(this.$bvModal, () => {})
      if (this.CookieData) {
        if (this.CookieData['cookieData']['custom:IsAdmin']) {
          this.cookieIsAdmin = this.CookieData['cookieData']['custom:IsAdmin']
        }
        if (this.CookieData['cookieData']['custom:ProdBaseCode']) {
          this.cookieProdBaseCode = this.CookieData['cookieData']['custom:ProdBaseCode']
        }
        if (!this.searchProductionBaseCode) {
          this.searchProductionBaseCode = this.cookieProdBaseCode
        }
      }
    },
    setMaterialsAndEquipmentAdjustmentListURL () {
      this.materialsAndEquipmentAdjustmentListURL = this.config.materialsAndEquipmentAdjustmentListURL
      if (this.cookieProdBaseCode) {
        if (this.allowProdBaseList.includes(this.cookieProdBaseCode)) {
          let prodBaseCodeParam = '?prodBaseCode=' + this.cookieProdBaseCode
          this.materialsAndEquipmentAdjustmentListURL += prodBaseCodeParam
          this.isAllowedAccess = true
        }
      }
    },
    setDeliveryEvaluationURL () {
      this.deliveryEvaluationURL = this.config.deliveryEvaluationURL
      if (this.cookieProdBaseCode) {
        let prodBaseCodeParam = '?prodBaseCode=' + this.cookieProdBaseCode
        this.deliveryEvaluationURL += prodBaseCodeParam
      }
    }
  },
  computed: {
  },
  watch: {
  },
  mounted: async function () {
    await this.setCookieData()
    if (JSON.parse(localStorage.getItem('isOrderPageBack'))) {
      this.pageBackSetUp()
    } else {
      this.searchOrder()
    }
    this.setMaterialsAndEquipmentAdjustmentListURL()
    this.setDeliveryEvaluationURL()
  }
}
</script>

<style scoped>
table > thead > tr > th {
  background-color: #161C3D !important;
  border: 1px solid #dee2e6 !important;
  color: #fefefe;
  font-weight: normal;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
table {
  border-collapse: separate;
  border-spacing: 0px;
}
thead {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
}
th, td {
  padding: 0px 10px !important;
}
.button-font-small {
  font-size: 95%;
}
.white-line {
background-color: #fff;
}
.white-line:hover {
background-color: #d9efff !important;
}
.gray-line {
background-color: #eefdff;
}
.gray-line:hover {
background-color: #d9efff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderList.vue